import React from 'react';
import cx from 'clsx';
import { fade, makeStyles, Theme } from '@material-ui/core/styles';
import Skeleton, { SkeletonProps } from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    backgroundColor: fade(theme.palette.text.primary, 0.12)
  }
}));

const StyledSkeleton = ({ className, ...rest }: SkeletonProps): React.ReactElement => {
  const classes = useStyles();
  return <Skeleton className={cx(classes.root, className)} {...rest} />;
};

export default StyledSkeleton;
